import React from 'react';
import { contactInfo } from '../../data/dreamlandData';
import { Phone, Mail, MapPin, Facebook, Instagram, ArrowUp } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1B3D6E] text-white">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <h3 className="text-2xl font-['Playfair_Display'] font-bold mb-1">Dreamland</h3>
            <span className="text-xs tracking-[0.3em] uppercase text-[#F5C518] font-semibold">Inn</span>
            <p className="text-white/60 text-sm leading-relaxed mt-4">
              Seaside cottages surrounded by nature. Your dream beach vacation destination at Murud, Dapoli.
            </p>
            <div className="flex gap-3 mt-5">
              <a href={contactInfo.facebook} target="_blank" rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#F5C518] hover:text-[#1B3D6E] transition-colors duration-300">
                <Facebook size={16} />
              </a>
              <a href={contactInfo.instagram} target="_blank" rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#F5C518] hover:text-[#1B3D6E] transition-colors duration-300">
                <Instagram size={16} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-['Playfair_Display'] font-semibold text-lg mb-5 relative">
              Quick Links
              <span className="absolute bottom-[-8px] left-0 w-8 h-0.5 bg-[#F5C518]" />
            </h4>
            <ul className="space-y-3 mt-4">
              {['Home', 'About Us', 'Rooms', 'Gallery', 'Contact Us'].map((link) => (
                <li key={link}>
                  <a href={`/#${link.toLowerCase().replace(/\s/g, '')}`}
                    className="text-white/60 text-sm hover:text-[#F5C518] hover:pl-1 transition-all duration-300">
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-['Playfair_Display'] font-semibold text-lg mb-5 relative">
              Contact Info
              <span className="absolute bottom-[-8px] left-0 w-8 h-0.5 bg-[#F5C518]" />
            </h4>
            <ul className="space-y-4 mt-4">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-[#F5C518] flex-shrink-0 mt-0.5" />
                <span className="text-white/60 text-sm">{contactInfo.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-[#F5C518] flex-shrink-0" />
                <a href={`tel:${contactInfo.phone}`} className="text-white/60 text-sm hover:text-[#F5C518] transition-colors">
                  {contactInfo.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={18} className="text-[#F5C518] flex-shrink-0" />
                <a href={`mailto:${contactInfo.email}`} className="text-white/60 text-sm hover:text-[#F5C518] transition-colors break-all">
                  {contactInfo.email}
                </a>
              </li>
            </ul>
          </div>

          {/* Opening Hours */}
          <div>
            <h4 className="font-['Playfair_Display'] font-semibold text-lg mb-5 relative">
              Hours & Check-in
              <span className="absolute bottom-[-8px] left-0 w-8 h-0.5 bg-[#F5C518]" />
            </h4>
            <ul className="space-y-3 mt-4 text-white/60 text-sm">
              <li className="flex justify-between">
                <span>Check-in</span>
                <span className="text-[#F5C518]">12:00 PM</span>
              </li>
              <li className="flex justify-between">
                <span>Check-out</span>
                <span className="text-[#F5C518]">10:00 AM</span>
              </li>
              <li className="flex justify-between">
                <span>Restaurant</span>
                <span className="text-[#F5C518]">7AM - 10PM</span>
              </li>
              <li className="flex justify-between">
                <span>Reception</span>
                <span className="text-[#F5C518]">24/7</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 py-5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-white/40 text-sm">
            &copy; {new Date().getFullYear()} Dreamland Inn. All rights reserved.
          </p>
          <p className="text-white/30 text-xs">
            Beach Resort at Murud, Dapoli
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;